/**
 * unsub.js
 * handels unsubscribing a contact from link2rsvp
 */
import axios from "axios";
import React, {useState} from "react";
import { useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import "../../style/rsvpEventStyle.css";
import ErrorMessage from "../Misc/ErrorMessage";
import SuccMessage from "../Misc/succMessage";

/**
 * page that renders when invited user chooses to unsub from emails
 */
function UnSub() {
    const[/*contactId,*/ setContactId] = useState("");
    const {id} = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [succMessage, setSuccMessage] = useState("");


   /**
    * function deleteContact()
    * will delete a contact that has choosen to unsubscribe
    */
    async function deleteContact() {
        //trys to delete the contact based off of contact id
        try {
            const response = await axios.delete(`https://link2rsvp.herokuapp.com/contact/${id}`);
            console.log(response);
            setSuccMessage(response.data.succMessage);
        } catch (err) {
            if(err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
    }

    
return (
    <div>
        <div id="head">
            <h1 id="headp">LINK2RSVP</h1>
        </div>
        {
            succMessage && (
                <SuccMessage
                message={succMessage}
                clear={() => setSuccMessage(null)}
                />
            )
        }
        {
            errorMessage && (
                <ErrorMessage
                message={errorMessage}
                clear={() => setErrorMessage(null)}
                />
            )
        }

        <div id="unsub">
            <h3>Unsubscribe from emails from LINK2RSVP</h3>
            <Form.Group className="mb=3" id="123">
                <Form.Label htmlFor="unsubForm"></Form.Label>
                <Form.Control
                alias="yes"
                placeholder="Enter ID from email"
                id="unsubForm"
                type="text"
                value={id}
                onChange={(e) => setContactId(e.target.value)}
                />
            </Form.Group>
            <Button variant="secondary" onClick={deleteContact} id="unsub-btn">Unsubscribe</Button>
        </div>
    </div>
);
}

export default UnSub;